// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ProductSelectorState from "@insite/client-framework/Store/Components/ProductSelector/ProductSelectorState";
import { ProductAutocompleteItemModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import ProductSelectorStateExtension from "@store/Extensions/Store/Components/ProductSelector/ProductSelectorState";
import { ReducerActions } from "@store/Framework/Types/Common";
import { ExtendState } from "@toolkit/Framework/Types/ReduxActions";
import { Draft } from "immer";

const initialState: ExtendState<ProductSelectorState, ProductSelectorStateExtension> = {};

const actions: ReducerActions<ProductSelectorState> = {
    "Components/ProductSelector/UpdateOptions": (
        draft: Draft<ProductSelectorState>,
        action: { result: ProductModel },
    ) => {
        /* Store Custom Code - Start */
        const selectedResult = draft.searchResults?.find(x => x.id === action.result.id);

        if (selectedResult) {
            draft.searchResults = [selectedResult];
            return;
        }
        /* Store Custom Code - End */

        draft.searchResults = [
            {
                id: action.result.id,
                image: action.result.mediumImagePath,
                brandName: action.result.brand?.name ?? "",
                erpNumber: action.result.productNumber,
                brandDetailPagePath: "",
                name: action.result.productTitle,
                url: action.result.urlSegment,
                isNameCustomerOverride: false,
                manufacturerItemNumber: action.result.manufacturerItem,
                title: action.result.productTitle,
                // Store Custom Code
                properties: action.result.properties,
            } as ProductAutocompleteItemModel,
        ];
    },
};

const reducer = createTypedReducerWithImmer(initialState as ProductSelectorState, actions);
export type ProductSelectorActions = Parameters<typeof reducer>[1];
export default reducer;
